export const TABS = {
    BASIC: { value: "BASIC", text: "기본입력" },
    PAGES: { value: "PAGES", text: "필드입력" },
};
